import { MAMEditorGuard, SuperUserGuard } from "../../guards/permission.guard";
import { Routes } from "@angular/router";
import { LayoutEditorComponent } from "./layout-editor/layout-editor.component";
import { SchedulerComponent } from "../scheduler/scheduler.component";

export const LayoutsRoutes: Routes = [
  {
    path: "layouts",
    component: SchedulerComponent,
    canActivate: [MAMEditorGuard],
    children: [
      { path: "new", component: LayoutEditorComponent },
      { path: "edit/:id", component: LayoutEditorComponent },
      { path: "**", redirectTo: "new" },
    ],
  },
];
